import { DatePicker, Form, Input, Typography } from "antd";

const { Text } = Typography;

const CustomTextInput = ({
  label,
  name,
  rules,
  password = false,
  date = false,
  phone = false,
  starLabel = true,
  inputProps = {},
  formItemProps = {},
}) => {
  const labelContent = (
    <>
      <Text>{label}</Text>
      <Text style={{ color: "#940808" }}>*</Text>
    </>
  );
  const labelOnly = <Text>{label}</Text>;

  const phoneAddon = (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <Text>+62</Text>
    </div>
  );

  return (
    <Form.Item
      label={starLabel ? labelContent : labelOnly}
      name={name}
      rules={rules}
      required={false}
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      {...formItemProps}
    >
      {password ? (
        <Input.Password size="large" style={{ fontSize: 14 }} {...inputProps} />
      ) : date ? (
        <DatePicker
          style={{ width: "100%", fontSize: 14 }}
          size="large"
          placeholder=""
          {...inputProps}
        />
      ) : (
        <Input
          size="large"
          style={{ fontSize: 14 }}
          addonBefore={phone ? phoneAddon : null}
          {...inputProps}
        />
      )}
    </Form.Item>
  );
};

export default CustomTextInput;
